module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 17 Farma Pasa - Do kraja.fb8ae22b.mp3";